import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import SmardxWhiteLogo from "../../assets/smardx_white_logo.png";

const SmardxTitle = ({ size = 50 }) => {
  // El modo se lee del tema de MUI y no del contexto de la app: dentro de un
  // AlcanceOscuro (pantallas de acceso, #1439) el tema es dark aunque la app
  // esté en claro, y el logo tiene que seguir al fondo que tiene debajo.
  const isDark = useTheme().palette.mode === "dark";

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ height: "100%" }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundImage: `url(${SmardxWhiteLogo})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: size,
          height: size,
          fontFamily: "Proxima Nova Condensed, sans-serif",
          filter: isDark ? "none" : "invert(1)",
        }}
      />
      <Typography
        sx={{
          fontWeight: "700",
          fontSize: `${size / 1.3}px`,
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontFamily: "Proxima Nova Condensed, sans-serif",
          mx: 0,
          color: "text.primary",
        }}
        variant="h1"
      >
        Smart
        <Box component="span" sx={{ color: "primary.main" }}>
          Dx
        </Box>
      </Typography>
    </Stack>
  );
};

export default SmardxTitle;
